module.exports = __webpack_public_path__ + "media/svg/facebook-dc238aad.svg";